/** @flow */

export const employeeMessages = {
  en: {
    EMPLOYEE_CREATED: "Employee was successfully created",
    EMPLOYEE_UPDATED: "Employee was successfully updated",
    EMPLOYEE_ROLE_ADDED: "Employee Role was successfully added",
    EMPLOYEE_ROLE_DELETED: "Position deleted",
    EMPLOYEE_ROLE_UPDATED: "Employee Position was successfully updated",
    MEDICATION_ADDED: "Medication was successfully added",
    MEDICATION_UPDATED: "Medication was successfully updated",
    MEDICATION_REMOVED: "Medication was successfully removed",
    ALLERGY_ADDED: "Allergy was successfully added",
    ALLERGY_UPDATED: "Allergy was successfully updated",
    ALLERGY_REMOVED: "Allergy was successfully removed",
    HISTORY_ITEM_ADDED: "Medical History Item was successfully added",
    HISTORY_ITEM_REMOVED: "Medical History Item was successfully removed",
    ALERT_EXCLUSION_ADDED: "Employee Alert Exclusion was successfully added",
    ALERT_EXCLUSION_UPDATED: "Employee Alert Exclusion was successfully updated",
    ALERT_EXCLUSION_REMOVED: "Employee Alert Exclusion was successfully removed",
    USER_ACCOUNT_UPDATED: "User account successfully updated",
    USER_ACCESS_UPDATED: "User access was successfully updated",
    USER_ACCOUNT_LOCKED: "User Account was successfully locked",
    USER_ACCOUNT_UNLOCKED: "User account was successfully unlocked",
    EMAIL_PASSWORD_INSTRUCTIONS_SENT:
      "Email with password reset instructions was successfully sent",
    AREA_OF_ACCESS_SUCCESSFULLY_UPDATED: "Area of Access was successfully updated",
    RESET_OTP_SUCCESS: "OTP account successfully reset",
  },
};

export default {
  en: {
    REPORTING_VIEW: "Reporting View",
    ABSENCE_MONITORING: "Absence Monitoring",
    ABSENCE_DETAILS: "Absence Details",
    ABSENCE_ADMIN: "Absence Admin",
    ABSENCE_DETAILS_WITH_NAME: "{name}: Absence Admin",
    HISTORY: "History",
    ACTION_SUMMARY: "Action Summary",
    ACTIVE_ROLES: "Active Roles",
    ADD_ABSENCE: "Add Absence",
    UPDATE_ABSENCE: "Update Absence",
    EDIT_ABSENCE: "Edit Absence",
    ADD_ROLE: "Add Role",
    EDIT_ROLE: "Edit Role",
    ALERT_NAME: "Alert Name",
    TOTAL_DOCUMENTS: "Total Documents",
    ACCEPTED_REFERRAL: "Accepted Referral",
    RTW_DATE_AT_REFERRAL: "RTW Date at Referral",
    GENERAL_DOCUMENTS: "General Documents",
    ABSENCE_SPECIFIC_DOCUMENTS: "Absence Specific Documents",
    TOTAL_FIT_NOTES: "Total Fit Notes",
    EMPLOYMENT_DETAILS: "Employment Details",
    EMPLOYMENT_DETAILS_WITH_NAME: "{name}: Employment Details",
    EMPLOYMENT_SUMMARY: "Employment Summary",
    CONTACT_DETAILS: "Contact Details",
    DATE_EXCLUDED: "Date Excluded",
    DISABLE_ALERTS: "Exclude An Employee From Alerts",
    EMPLOYEE_RECORD: "Employee Record",
    EMPLOYEE_DETAILS_TAB_INFO:
      "The employee details are summarised below. Included are personal, employment and contact details. A list of any past or present employment positions are also shown, including the department the employee works in and for how many hours a week.",
    EMPLOYEE_ABSENCES_TAB_INFO:
      "Each of the employee’s absences are listed below. For each absence the duration, type and reason is shown. The list can be exported to Excel and can also be filtered. Selecting to view an absence will take you to the Absence Details page, where you can see the complete record.",
    EMPLOYEE_STATISTICS_TAB_INFO:
      "These statistics show how the employee’s absence levels compare to the average of the other employees that work in the same department. The employee is also compared against the organisation average. The purpose of this comparison is to highlight where the employee has excessive absence levels that should be reviewed.",
    EMPLOYEE_NOTES_TAB_INFO:
      "These are notes that have been added to the employee’s absence history. They include general notes that relate to the employee themselves, as well as absence specific notes that relate to a particular issue or event. They are designed to record ad-hoc activities such as duty of care calls, and follow-up meetings.",
    EMPLOYEE_DOCUMENTS_TAB_INFO:
      "These are documents  that have been uploaded to the employee absence record. They include general documents that relate to the employee themselves, as well as absence specific documents, such as fit notes, warnings, important letters and other relevant documentation.",
    EMPLOYEE_CONTACTS_TAB_INFO:
      "When the employee reports an absence notifications are sent to the relevant contacts to make them aware. The employee may also be a notification contact for other staff, for whom they will receive notifications whenever they report an absence. The Data Exposure Index (D.E.I) indicates how much sensitive data each contact sees.",
    EMPLOYEE_MONITORING_TAB_NO_SERVICE:
      "GoodShape does not track the attendance management procedure for your organisation.",
    EMPLOYEE_MONITORING_TAB_INFO:
      "This tab shows any formal absence monitoring reviews that have taken place with the employee and tracks their movement through the attendance management procedure. Their current level is shown at the top, and a history of their past levels is shown underneath.",
    EMPLOYEE_REFERRALS_TAB_NO_SERVICE:
      "GoodShape does not track Occupational Health referrals for your organisation.",
    EMPLOYEE_REFERRALS_TAB_INFO:
      "If an employee reports an absence that triggers a referral to a treatment provider, such as Occupational Health, it will appear here. This includes instances where an employee self-refers into a service (Employee Referral) or where a manager approved the referral (Manager Referral). Accepted and Declined referrals are shown.",
    EMPLOYEE_ADMIN_TAB_INFO:
      "Here you can manage the employees access to the platform. Their Access Level determines what content they can use and how much data they can see. For privileged user types, an additional Area of Access scope becomes available, letting you choose the exact hierarchy area the employee can/cannot access.",
    DELETE_EMPLOYEE_RECORD: "Delete Employee Record",
    NO_KEEP_EMPLOYEE: "No, keep employee",
    YES_DELETE_EMPLOYEE: "Yes, delete employee",
    YOU_SURE_WANT_DELETE_EMPLOYEE_DETAILED_DESCRIPTION:
      "Are you sure you want to delete this employee? This action is irreversible, and the employee record, along with any associated notes, documents and absences, will no longer be available.",
    EXCLUDED_ALERTS: "Excluded Alerts",
    EXCLUDED_BY: "Excluded By",
    EXCLUDED_FROM: "Excluded From",
    EXCLUDED_TO: "Excluded To",
    PERSONAL_DETAILS: "Personal Details",
    EMPLOYEE_DETAILS_WITH_NAME: "Details: {name}",
    EMPLOYEES_SEARCH_SCREEN: "Employees Search Screen",
    EMPLOYEE_ADMIN_WITH_NAME: "{name}: Employee Admin",
    EDIT_PERSONAL_DETAILS: "Edit Personal Details",
    ROLE_SUMMARY: "Role Summary",
    SECURITY_DETAILS: "Security Details",
    SPECIAL_CONTACT_ROLES: "Special Contact Roles",
    TOTAL_ACTIONS: "Total Actions",
    TOTAL_SALARY: "Total Salary",
    TOTAL_WEEKLY_CONTRACTED_HOURS: "Total Weekly Contracted Hours",
    TOTAL_WORKING_DAYS_YEAR: "Total Working Days/Year",
    EMPLOYEE_SEARCH: "Employee Search",
    SEARCH_CRITERIA: "Search Criteria",
    ADD_NEW_EMPLOYEE: "Add New Employee",
    SHOW_EMPLOYEE_RESULTS: "Showing {shownResults} of {totalResults} results",
    SHOW_EMPLOYEE_TOTAL:
      'Total Results: {total} (<strong>Active: {activeEmployees}</strong> <strong class="text-pumpkin-orange">Inactive: {inactiveEmployees}</strong>)',
    ADD_EMPLOYEE: "Add Employee",
    EDIT_EMPLOYEE: "Edit Employee",
    CONFIGURE_NOTIFICATION: "Configure Notification",
    CONFIGURE_CONTACT: "Configure Contact",
    SEARCH: "Search",
    SEARCH_RESULTS: "Search Results",
    EMPLOYEE_REF: "Employee Ref.",
    FIRST_NAME: "First Name",
    SURNAME: "Surname",
    DATE_OF_BIRTH: "Date of Birth",
    DEPARTMENT: "Department",
    DEPARTMENT_ABSENT_FROM: "Department Absent From",
    STATUS: "Status",
    EMPLOYEE_ID: "Employee ID",
    SELECT: "Select",
    COMPANY_NAME: "Company Name",
    MEDICAL_DETAILS: "Medical Details",
    MEDICATIONS: "Medications",
    MEDICATION: "Medication",
    MEDICAL_DETAILS_TABLE_TITLE_NOTES: "Notes",
    MEDICAL_DETAILS_TABLE_TITLE_STATUS: "Status",
    DATE_RECORDED: "Date Recorded",
    RECORDED_BY: "Recorded By",
    ASSOCIATED_ABSENCE: "Associated Absence",
    ACTION: "Action",
    ADD_MEDICATION: "Add Medication",
    CANCEL: "Cancel",
    SAVE_ITEM: "Save Item",
    ALLERGY: "Allergy",
    ALLERGIES: "Allergies",
    ADD_ALLERGY: "Add Allergy",
    MEDICAL_HISTORY: "Medical History",
    TYPE: "Type",
    ITEM: "Item",
    ADDITIONAL_NOTES: "Additional Notes",
    ADD_ITEM: "Add Item",
    REMOVE_MEDICATION: "Remove Medication",
    REMOVE_CONFIRMATION: "Are you sure would like to remove {item} from this employee's record?",
    REMOVE_ALLERGY: "Remove Allergy",
    REMOVE_ITEM: "Remove Item",
    REPORT_NEW_ABSENCE: "Report New Absence",
    CHANGELOG_ITEM: "Change Log - {item}",
    CHANGELOG: "Change Log",
    CHOOSE_CLIENT: "Choose client",
    NOT_ASSOCIATED_ABSENCE: "Not associated to any absence",
    INVALID_DATE: "Invalid date",
    MY_DETAILS: "My Details",
    MY_INFORMATION: "My Information",
    CONTACT_INFO: "Contact Info",
    USER_INFO: "User Info",
    HOME_PAGE: "Home Page",
    CHANGE_PASSWORD: "Change Password",
    MY_ACCOUNT_DETAILS: "My Account Details",
    TITLE: "Title",
    DESCRIPTION: "Description",
    DATE_AVAILABLE: "Date Available",
    MY_ABSENCES: "My Absences",
    ABSENCE: "Absence",
    RTW_INTERVIEW: "RTW Interview",
    QUESTIONS_AND_ANSWERS: "Questions & Answers",
    QUESTION: "Question",
    QUESTION_ID: "Question ID",
    DAY_TYPE: "Day Type",
    ROLE: "Role",
    TIME_DUE_TO_WORK: "Time Due To Work",
    HOURS_DUE_TO_WORK: "Hours Due To Work",
    HOURS_LOST: "Hours Lost",
    DAYS_LOST: "Days Lost",
    SPELLS: "Spells",
    referral_ID: "Referral Id",
    REFERRAL_REASON: "Referral Reason",
    DATE_TRIGGERED: "Date Triggered",
    WELLBEING_SUPPLIER: "Wellbeing Supplier",
    ALERT_ID: "Alert ID",
    JOB_TITLE: "Job Title",
    POSITION_ID: "Position ID",
    POSITION_REF: "Position Ref",
    YOU_SURE_WANT_DELETE_POSITION_DETAILED_DESCRIPTION:
      "Are you sure you want to delete this position? This action is irreversible, and the position can no longer be used to record time lost due to absence. Any notification contacts exclusively for this position will also be removed.",
    NO_KEEP_POSITION: "No, keep position",
    YES_DELETE_POSITION: "Yes, delete position",
    YOU_DON_T_HAVE_PRIVILEGE_EMPLOYEE_DELETE:
      "You don't have 'privilege.employee.delete' priviledge so you can't delete that absence",
    WEEKLY_CONTRACTED_HOURS: "Weekly Contracted Hours",
    DAYS_PER_YEAR: "Days Per Year",
    EFFECTIVE_FROM_DATE: "Effective From Date",
    EFFECTIVE_END_DATE: "Effective End Date",
    SALARY: "Salary",
    WORKING_DAYS_YEAR: "Working Days / Year",
    DATE_ASSIGNED: "Date assigned",
    ROLE_NAME: "Role Name",
    ASSIGNED_BY: "Assigned By",
    TOTAL_FTE: "Total FTE",
    FTE: "FTE",
    ABSENCES: "Absences",
    INTERACTIONS: "Interactions",
    REVISIONS: "Revisions",
    ADD_INTERACTION: "Add Interaction",
    ADVISOR: "Advisor",
    INTERACTION_NOTES: "Interaction Notes",
    NOTIFICATION_ID: "Notification ID",
    METHOD: "Method",
    RECIPIENTS: "Recipients",
    CONSENT_TO_SHARE: "Consent to Share",
    DATE_CAPTURED: "Date Captured",
    ABSENCE_ID: "Absence ID",
    START: "Start",
    FIT_DATE: "FIt Date",
    RTW_DATE: "RTW Date",
    ABSENCE_REASON_CLASSIFICATION: "Absence Reason Classification",
    CONSENT_WITHHELD: "Consent Withheld",
    CONSENT_STATUS: "Consent Status",
    DATE_REPORTED: "Date Reported",
    DATE_CLOSED: "Date Closed",
    REPORTED_BY: "Reported By",
    ACCOUNT: "Account",
    ACCOUNT_DETAILS_WITH_NAME: "{name}: Account",
    UNLOCK_ACCOUNT: "Unlock Account",
    LOCKED_ACCOUNT_MESSAGE: "Account is locked.",
    ACCOUNT_DETAILS: "Account Details",
    ROLE_DETAILS: "Role Details",
    POSITION_HISTORY: "Position History",
    DATE_REGISTERED: "Date Registered",
    ACCOUNT_STATUS: "Account Status",
    ACCESS_LEVEL: "Access Level",
    ADVANCED_USER: "Advanced User",
    MANAGER: "Manager",
    CLIENT_SUPPLIER: "Supplier",
    RESET_PASSWORD: "Reset Password",
    AREA_OF_ACCESS: "Area of Access",
    AREA_OF_ACCESS_SUCCESSFULLY_UPDATED: "Area of Access was successfully updated",
    AREAS_INCLUDED: "Areas Included",
    AREAS_EXCLUDED: "Areas Excluded",
    UNIT_NAME: "Unit Name",
    SELECTED_AREAS: "Selected Areas",
    EXCLUDED_AREAS: "Excluded Areas",
    RECENT_LOGINS: "Recent Logins",
    SAVED_REPORTS: "Saved Reports",
    MANAGER_FOCUS_LIST: "Manager Focus List",
    FOCUS_LISTS: "Focus Lists",
    MONITOR: "Monitor",
    ORGANISATIONAL_UNIT_FOCUS_LIST: "Organisational Unit Focus List",
    COMPLIANCE_TRENDS: "Compliance Trends",
    ABSENCE_REASON_TRENDS: "Absence Reason Trends",
    EMPLOYEE_FOCUS_LIST: "Employee Focus List",
    ABSENCE_RATE_TRENDS: "Absence Rate Trends",
    DATE_TIME: "Date and Time",
    IP_ADDRESS: "IP Address",
    BROWSER: "Browser",
    REFERRAL_ID: "Referral ID",
    RESULT: "Result",
    SELECT_AREAS: "Select Areas",
    FIND_DEPARTMENT: "Find Department",
    EVENT_DETAILS: "Event Details",
    MONITORING_WITH_NAME: "{name}: Monitoring",
    EMPLOYEES: "Employees",
    ACTIVITY_HISTORY: "Activity History",
    ACTIVITY_SUMMARY: "Activity Summary",
    ACTIVITY_HISTORY_ITEM_TITLE: "Activity #{id} - {type}",
    INTERVIEW_ABSENCE_ITEM_TITLE: "RTW Interview #{id}",
    STEP_ADDITIONAL_SUPPORT_ACTIONS: "Support Provided to Employee",
    NOT_IN_PROCESS: "Not in Process",
    ACTIVITY_ID: "Activity ID",
    TASK_TYPE: "Task Type",
    ABSENCE_MONITORING_REVIEW: "Absence Monitoring Review",
    OVERDUE_TASKS: "Overdue Tasks",
    TASKS_STILL_WITHIN_KPI_TARGET: "Tasks Still Within KPI Target",
    WELLBEING_REFERRALS: "Wellbeing Referrals",
    REFERRALS_WITH_NAME: "{name}: Referrals",
    ACTIVITY_DATE: "Activity Date",
    ACTIONED_BY: "Actioned By",
    LOG_SELF_REFERRAL: "Log Self Referral",
    MANUAL_REFERRAL: "Wellbeing Referral",
    REFERRALS: "Referrals",
    ABSENCE_MONITORING_REVIEWS: "Absence Monitoring Reviews",
    MONITORING_REVIEWS: "Monitoring Reviews",
    RTW_INTERVIEWS: "RTW Interviews",
    DOCUMENTS: "Documents",
    CONTACTS: "Contacts",
    ADD_DOCUMENT: "Add Document",
    SUPPROTED_FILE_TYPES: "Supported file types",
    SUPPROTED_FILE_TYPES_DESCRIPTION: ".pdf, .png, .jpeg, .txt, .jpg, .csv, .zip, .xml.",
    EDIT_DOCUMENT: "Edit Document",
    SAVE_NOTE: "Save Note",
    ADD_MANAGER_NOTE: "Add Manager Note",
    EDIT_MANAGER_NOTE: "Edit Manager Note",
    DATE_UPLOADED: "Date Uploaded",
    UPLOADED_BY: "Uploaded By",
    DESELECT_ALL: "Deselect All",
    RELATED_ABSENCE_ID: "Related Absence ID",
    RECORD: "record",
    RECORDS: "record(s)",
    SELECTED: "selected",
    TASKS_WITH_NAME: "{name}: Tasks",
    MONITORING_UPDATE: "Monitoring Update",
    OUTSTANDING_TASKS: "outstanding tasks",
    EMPLOYEE_NAME: "Employee Name",
    DATE_ABSENCE_REPORTED: "Date Absence Reported",
    ABSENCE_START_DATE_TIME: "Absence Start Date/Time",
    RTW_DATE_DATE_TIME: "RTW Date Date/Time",
    ORGANISATION_NAME: "Organisation Name",
    EMPLOYEMENT_INFO: "Employment Info",
    EMPLOYMENT_START: "Department",
    SERVICE_LENGTH: "Service Length",
    CONTRACTED_HOURS: "Contracted Hours",
    ANNUAL_WORKING_DAYS_AVAILABLE: "Annual Working Days Available",
    PRIMARY_EMAIL_ADDRESS: "Primary Email Address",
    SECONDARY_EMAIL_ADDRESS: "Secondary Email Address",
    PERSONAL_HOME_PHONE: "Personal Home Phone",
    HOME_PHONE: "Home Phone",
    MOBILE_PHONE: "Mobile Phone",
    WORK_PHONE: "Work Phone",
    WORK_PHONE_FOR_NOTIFICATIONS: "Work Phone for Notifications",
    PAGE_NUMBER: "Showing",
    PAGE_OF: "of",
    REMOVE_DOCUMENT_CONFIRMATION:
      "Are you sure would like to delete {documentName} from {employeeName} record?",
    REMOVE_DOCUMENT_MODAL_TITLE: "Remove Document",
    RETURN_TO_WORK_INTERVIEWS: "RTW Interviews",
    ALERT_TRIGGERED: "Alert Triggered",
    TASK_NOT_COMPLETED_YET: "Task not completed yet",
    EMPLOYEE_REFERRAL_DECISION: "Wellbeing Referral",
    MANAGER_REFERRAL_DECISION: "Wellbeing Referral",
    VIEW_ALERTS_TRIGGERED: "View Alerts Triggered",
    ASSIGNED_SHIFT_PATTERNS: "Assigned Shift Patterns",
    GENDER: "Gender",
    MALE: "Male",
    FEMALE: "Female",
    HARD_OF_HEARING: "Hard of Hearing",
    DISABILITY: "Disability",
    SECONDARY_REF: "Secondary Ref",
    EMPLOYMENT_TYPE: "Employment Type",
    EMPLOYMENT_START_DATE: "Employment Start",
    EMPLOYMENT_END_DATE: "Employment End",
    SECURITY_QUESTION_FIELD: "Security Question",
    ANSWER: "Answer",
    NON_SERVICE: "Non Service",
    LAND_PHONE: "Land Phone",
    BACKUP_EMAIL: "Back-Up Email",
    IS_NON_SERVICE: "Is Non Service",
    FIRSTCARE_ID: "GoodShape ID",
    NAME_OF_FIRST_SCHOOL: "Name of first school",
    NAME_OF_PET: "Name of pet",
    NAME_OF_BIRTH_PLACE: "Name of birth place",
    MOTHER_MAIDEN_NAME: "Mother's maiden name",
    NAME_OF_FIRST_COMPANY: "Name of first company",
    SOURCE: "Source",
    ABSENCE_MAIN_DETAILS: "Main Details",
    START_FIT_RTW_DATES: "Start-Fit-RTW Dates",
    RTW: "RTW",
    MORE_INFORMATION: "More Information",
    AUTHORISED: "Authorised",
    INTERACTION: "Interaction",
    WHL: "WHL",
    WDL: "WDL",
    CDL: "CDL",
    INTERVIEW_DETAILS: "Interview Details",
    PERFORMED_BY: "Performed By",
    DETAILS: "Details",
    ADDED_ABSENCE_DETAILS: "Added {date} By {name}",
    WORK_RELATED_HEADER: "Work Related?",
    IS_ACCIDENTS_RELATED: "Accident?",
    ACCIDENT_RELATED_HEADER: "Accident Related?",
    DATE_ABSENCE_CLOSED: "Date Absence Closed",
    LAST_ABSENT_DAY: "Last Absent Day",
    DATE_INTERVIEW_DUE: "Date Interview Due",
    COMPLETED_BY: "Completed By",
    TIME_TO_COMPLETE: "Time to Complete",
    COMPLIANT: "Compliant",
    COMPLETE_RTW_FORM: "Complete RTW Interview Form Now",
    CANCEL_RTW_FORM: "Cancel RTW Interview",
    FIRST_NAME_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system.",
    SURNAME_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system.",
    DOB_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Surname to help identify employees. It is also used in the Age Group filter options on all reports.",
    HARD_OF_HEARING_TOOLTIP_TEXT:
      "This is used by GoodShape to flag hard of hearing employees on our system and to promote the use of the RNID TypeTalk service whenever these employees report absences",
    DISABILITY_TOOLTIP_TEXT:
      "This field is reference in alerts, which gives you the opportunity to exclude employees from the scope of an alert is their Disability status is set to Yes.",
    GENDER_TOOLTIP_TEXT: "This is used only for aggregated Gender Demographics report filters",
    SECURITY_QUESTION_TOOLTIP_TEXT:
      "This will be asked to your employee when they call to log an absence and part of the process through which we confirm their identity.",
    SECURITY_ANSWER_TOOLTIP_TEXT:
      "This is the answer that the employee must provide in order to verify their identify when contacting GoodShape.",
    EMPLOYEE_REF_TOOLTIP_TEXT:
      "This is used as a unique identifier for each employee to help GoodShape locate and access correct employee records",
    SECONDARY_REF_TOOLTIP_TEXT:
      "This is an entirely optional secondary reference number to help identify an employee.",
    ACTIVE_TOOLTIP_TEXT:
      "This defines if the employee record is active. If it is set to Inactive the employee will not be able to log into the system or report absences.",
    EMPLOYEE_TYPE_TOOLTIP_TEXT:
      "This defines the employment type for this record and will be used in the GoodShape Index Benchmarking reports.",
    EMPLOYMENT_START_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an individual started working for the organisation. The employee will only contribute to absence reports from this date onwards.",
    EMPLOYMENT_END_DATE_TOOLTIP_TEXT:
      "This date is used to identify when an employee ceased to work at the organisation. Employees will not contribute to absence rates past this date. It must be greater than the Employment Start Date. When entered, the employment end date will automatically be applid to any active positions held by the employee.",
    FIRSTCARE_ID_TOOLTIP_TEXT:
      "This is the unique ID of the employee record as it sits on the GoodShape database.",
    MOBILE_PHONE_TOOLTIP_TEXT:
      "This is the personal mobile number of the employee and may be used by GoodShape to contact the employee, to identify their record when calling to record an absenceor invite them to use the Text to Close service.",
    PRIMARY_EMAIL_ADDRESS_TOOLTIP_TEXT:
      "This is the employee's work email address and is used for receiving absence notifications and logging into the Insight system.",
    SECONDARY_EMAIL_ADDRESS_TOOLTIP_TEXT:
      "This is the personal email address of the employee and is not used for notifications",
    WORK_PHONE_TOOLTIP_TEXT:
      "This if the work phone number of the employee. If SMS Notifications are enabled and this employee is a notification contact, it is to this phone number that the SMS notifications will be sent.",
    WORK_PHONE_TOOLTIP_TEXT_1: "This if the work phone number of the employee. If ",
    WORK_PHONE_TOOLTIP_TEXT_2:
      " are enabled and this employee is a notification contact, it is to this phone number that the SMS notifications will be sent.",
    HOME_PHONE_TOOLTIP_TEXT:
      "This is the personal Landline/Home phone number of the employee and may be used by GoodShape to contact the employee or to identify their record when calling to record an absence.",
    NON_SERVICE_TOOLTIP_TEXT:
      "This defines if the employee record can be used to log absences (Service User) or if the record is in place for notifications/portal access but will not need to be used for logging absences (Non Service User). Non-Service records also do not contribute to Headcount totals or Absence Rate trends.",
    SMS_NOTIFICATION_TOOLTIP_LINK_TEXT: "SMS Notifications",
    EMPLOYEE_REFERRAL_WARNING_TOOLTIP_TEXT:
      "This employee already has an active or pending referral. You will need to visit your task queue and action that referral before any new referrals can be made.",

    POSITION_ID_TOOLTIP_TEXT: "This is the unique ID of the position on GoodShape's database.",
    EFFECTIVE_FROM_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an employee started working in their role and, therefore, when they should contribute to absence reports for this position.",
    EFFECTIVE_END_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an employee ceases working in the role and will no longer contribute to absence reports.",
    POSITION_REF_TOOLTIP_TEXT:
      "This  field is for adding a unique reference number for the position and is entirely optional if an employee only has one positon. If an employee has two or more positions then this value must be unique for each position.",
    JOB_TITLE_TOOLTIP_TEXT:
      'This field is used to display the employees job title in several reports throughout the system. If a Job Title is not supplied it will default to "Unassigned".',
    STAFF_GROUP_TOOLTIP_TEXT_1:
      "This is an optional field but its use is encouraged. Staff Groups present an opportunity to look at absence from a different perspective by comparing different occupations against each other. A Staff Group filter exists in most reports and the list of Staff Group types that appear on this drop down can be managed on the ",
    STAFF_GROUP_TOOLTIP_TEXT_2: " page in Service Admin.",
    STAFF_GROUP_TOOLTIP_LINK_TEXT: "Staff Group",
    DEPARTMENT_TOOLTIP_TEXT:
      "This field is used to assign an employees position to a department. Clicking on the field will open up the organisation's hierarchy, from which you will be able to select one department.",
    FTE_TOOLTIP_TEXT:
      "This data is used to create a Days Lost Per Full Time Equivalent (FTE) trend on the GoodShapeCentral portal. Any value between 0.00 and 1.00 can be entered.",
    WEEKLY_HOURS_TOOLTIP_TEXT:
      "This data is used to calculate the Hours Lost Absence % trend and is used to calculate the Hours Available side of the calculation. If this field is left blank a default of 37.5 hours will be used in reports.",
    DAYS_PER_YEAR_TOOLTIP_TEXT:
      "This data is used to calculate a Days Lost Absence % trend. If it is left blank a default of 228 will be used in reports.",
    CURRENCY_CODE_TOOLTIP_TEXT:
      "This confirms the currency of the employees salary. At present the only option is GDP (£).",
    USER_STATUS: "User Status",
    CURRENTLY_ABSENT: "Currently Absent?",
    PURE_CLOUD_INTERACTION_LINK: "Pure Cloud Interaction Link",
    INTERACTION_LINK: "Interaction Link",
    TUTORIAL: "Tutorial",
    USER_ACCOUNT_INTRODUCTION:
      "User Account settings control which areas of GoodShapeCentral a user can access, as well as which employee records they are allowed to see. As such, it is vital to ensure that each user has appropriate access settings.",
    ACCOUNT_INSTRUCTIONS: "Account Instructions",
    LOCK_UNLOCK_BUTTON: "Lock / Unlock Button",
    ADMIN_ACTIONS: "Admin Actions",
    DATA_EXPOSURE_TITLE: "Data Exposure Index",
    USER_TYPES: "User Types",
    USER_ACCOUNT_DATE_REGISTERED_DESCRIPTION:
      "This is the date and time that the user registered their GoodShape account.",
    USER_ACCOUNT_STATUS_DESCRIPTION: `This shows the status of the users account. "{enabled}" means the account is active. "{disabled}" means the account is inactive and cannot be used.`,
    USER_ACCOUNT_USER_STATUS_DESCRIPTION: `This is the status of the user. "{locked}" means the user has entered their password incorrectly 3 times and is now locked out of the system. "{unlocked}" means the user can use the account.`,
    USER_ACCOUNT_LOCK_UNLOCK_DESCRIPTION:
      "This button enables you to lock or unlock the users account as required.",
    USER_TYPE_DESCIPTION:
      "This shows the type of account the user currently has. For details of the differences between each account type, please see the video above, or the table below.",
    USER_DATA_EXPOSURE_INDEX_DESCRIPTION:
      "This is an indicator of how much employee data the user has access to when they log in, and ranges from Low to High.",
    USER_AREA_OF_ACCESS_DESCRIPTION:
      "This section controls which areas of your organisation the user has access to when they login. The user will see all employee records within their area of access, however the amount of data they see about each employee will depend on their User Type.",
    USER_AREAS_INCLUDED_DESCRIPTION:
      "The user will have access to any employee records within the Areas Included in their scope. Access includes the sub-departments of selected Areas by default.",
    USER_AREAS_EXCLUDED_DESCRIPTION:
      "You can exclude sub-departments from being accessible by the user. This means the user will have no access to the employees in these departments, unless they are a FULL notification contact for the employee.",
    USER_PASSWORD_RESET_DESCRIPTION:
      "This button will trigger a Password Reset Email to the user, enabling them to create a new password for their account.",
    USER_IMPERSONATE_DESCRIPTION:
      "This button allows you to login as the user and view the system through their eyes. This action is logged for auditing and security purposes. Impersonation sessions only last for 5 minutes.",
    USER_CHANGE_PASSWORD_DESCRIPTION:
      "This button allows you to set a new password for the user. You will then need to communicate your chosen password to the user via a safe method of communication.",
    NO_ACCESS_DESCRIPTION:
      "Account is disabled. This is for users who require no access to the system.",
    EMPLOYEE_DESCRIPTION:
      "Allows the user to access their own absence record only. This user type is intended for employees with no line manager responsibilities.",
    MANAGER_DESCRIPTION:
      "Allows access to all employee records for which the user is a FULL notification contact. This user type is intended for line managers.",
    ADVANCED_USER_DESCRIPTION:
      "Allows access to all employee records assigned to a department within their Area of Access but will only see sensitive information and tasks for the employees they are a FULL notification contact for. This user type is intended for Senior Managers in charge of an entire Division or Business Function.",
    FULL_ACCESS_DESCRIPTION:
      "Allows access to all employee records assigned to a department within their Area of Access, even if they are not a FULL notification contact for them. This user type is intended for HR personnel.",
    CLIENT_ADMIN_USER_DESCRIPTION:
      "Allows access to all employee records within their Area of Access, and to the Admin Console allowing complete control of the system. This user type is intended for HR leadership and administrators.",
    TREND_VIEWER_DESCRIPTION:
      "Allows access to aggregated Trend Reports only, but has no access to employee or absence records. This user type is intended for MI teams.",
    DATA_TRANSFER_DESCRIPTION:
      "Allows access to the Data Admin page only, for uploading and downloading SIP Files, but has no access to employee or absence records. This user type is intended for data managers.",
    EMPLOYEES_HELP_INTRODUCTION:
      "This page enables you to search for and access employee records. You will only be able to access records that your organisation has granted you permission to see. Each employee record includes their absence history and a range of management tools, such as the ability to log notes, upload documents or view return to work interviews.",
    EMPLOYEES_INSTRUCTIONS: "Employees Instructions",
    SEARCH_OPTIONS: "Search Options",
    SEARCH_SURNAME_DESCRIPTION: "This is the surname of the employee.",
    SEARCH_DATE_OF_BIRTH_DESCRIPTION:
      "This is the Date of Birth of the employee. Searches must use a DD/MM/YYYY format.",
    SEARCH_EMPLOYEE_REF_DESCRIPTION:
      "This is the unique employee reference number used by your organisation to identify employees.",
    SEARCH_DEPARTMENT_DESCRIPTION:
      'This option searches for employees that are assigned to a department that matches your free text input. It is a Like match instead of an Exact match. For example, if you searched "finance" it would return employees assigned to any department that has the text "finance" in its name.',
    SEARCH_USER_ID_DESCRIPTION:
      "This is the unique ID for the employee record that is generated by the GoodShape system.",
    SEARCH_STATUS_DESCRIPTION:
      "This option allows you to limit your search to active, inactive or all employees. Inactive means the employee has left the organisation previously.",
    SEARCH_ABSENCE_ID_DESCRIPTION:
      "If you know the details of an absence, but are not sure which employee it belongs to, this search option will allow you to enter an absence ID and then see the associated employee record.",
    SEARCH_EMAIL_ADDRESS_DESCRIPTION:
      "This option searches the primary email address field of employee records and will only return an employee record that is an exact match.",
    SEARCH_PHONE_NUMBER_DESCRIPTION:
      "This field allows you to search for an employee by phone number. Note that the search only checks the Work Phone Number, and does not check any personal phone numbers the employee has added to their account.",
    AUDIT_LOGS: "Audit Logs",
    DATA_SECURITY_NOTICE: "Security Notice",
    DATA_SECURITY_NOTICE_DESCRIPTION:
      "Employee records may contain confidential information and should be handled with care. You are only permitted to access employee records to fulfil your management responsibilities. Be aware of your surroundings when accessing any employee records.",
    DATA_SECURITY_LOGS_DESCRIPTION:
      "Accessing an employee record is logged for auditing and security purposes.",

    RECORD_CONTENTS: "Record Contents",
    RECORD_DETAILS_DESCRIPTION:
      "This page provides basic information about the employee, including personal, contact and employment information.",
    RECORD_ABSENCES_DESCRIPTION:
      "This page lists all the employee’s absences. You can filter and export the list. Clicking the magnifying glass will open the absence record.",
    RECORD_STATISTICS_DESCRIPTION:
      "This page provides benchmarking of the employee's absence rates against the average for their department and the organisation as a whole.",
    RECORD_NOTES_DESCRIPTION:
      "This page pulls together the manager notes from all absences into one place. General notes about the employee can also be added on this page.",
    RECORD_DOCUMENTS_DESCRIPTION:
      "This page pulls together the uploaded documents from all absences into one place. General documents about the employee can also be added on this page.",
    RECORD_NOTIFICATIONS_DESCRIPTION:
      "This page lists the individuals that are sent notifications about this employee's absence. A toggle can be used to see the list of individuals this employee receives notifications about.",
    RECORD_MONITORING_DESCRIPTION:
      "This page will only appear if your organisation has purchased the GoodShapeMonitor service for tracking employees through an attendance management procedure once they have triggered an absence policy alert.",
    RECORD_REFERRALS_DESCRIPTION:
      "This page will only appear if your organisation has purchased the GoodShapeNavigator service for tracking referrals to Occupational Health and other wellbeing services.",
    RECORD_ACCOUNT_DESCRIPTION:
      "This page only appears for Admin users and can be used manage the users account.",
    RECORD_EXPORT_DESCRIPTION:
      "Here you can export the entire Employee Record to a PDF download. This export includes all details, absences, notes and benchmarking statistics.",
    RESET_OTP: "Reset OTP",

    // NOTIFICATIONS
    NOTIFICATIONS: "Notifications",
    NOTIFICATIONS_WITH_NAME: "{name}: Notifications",
    NOTIFICATIONS_SENT_TO_WITH_NAME: "{name}: Notifications Sent To",
    NOTIFICATIONS_SENT_TO: "Notifications Sent To",
    NOTIFICATIONS_RECEIVED_FOR: "Notifications Received For",
    SENT_TO: "Sent To",
    NOTIFICATIONS_RECEIVED_FOR_WITH_NAME: "{name}: Notifications Received For",
    RECEIVED_FOR: "Received For",
    NOTIFICATIONS_FOR: "Notifications For",
    NOTIFICATIONS_SUMMARY: "Summary",
    NOTIFICATIONS_ADD_RECIPIENT: "Add Notification Contact",
    NOTIFICATIONS_SELECT_CONTACT: "Select Contact",
    NOTIFICATIONS_EDIT_RECIPIENT: "Edit Notification Contact",
    NOTIFICATIONS_DEPARTMENT_RECIPIENTS: "Department Recipients",
    NOTIFICATIONS_DEPARTMENT: "Department Notifications",
    NOTIFICATIONS_DEPARTMENT_CONTACT_ADMIN: "Department Contact Admin",
    NOTIFICATIONS_EMPLOYEE_REF: "Employee Ref",
    NOTIFICATIONS_EMPLOYEE_NAME: "Employee Name",
    NOTIFICATIONS_DEPARTMENT_REF: "Department Ref",
    NOTIFICATIONS_DEPARTMENT_NAME: "Department Name",
    NOTIFICATIONS_NOTIFICATION_TYPE: "Notification Type",
    NOTIFICATIONS_DATE_ADDED: "Date Added",
    NOTIFICATIONS_ADDED_BY: "Added By",
    ALL_POSITIONS: "All Positions",
    TRANSFER: "Transfer",
    COPY: "Copy",
    DELETE_NOTIFICATION: "Delete Notification",
    DELETE_NOTIFICATION_CONFIRMATION: "Are you sure would like to delete {name} notification?",
    DELETE_NOTIFICATIONS_CONFIRMATION: "Are you sure would like to delete selected notifications?",
    NOTIFICATION_CONTACTS: "Notification Contacts",
    FULL_NOTIFICATION_CONTACTS: "Full Notification Contacts",
    STANDARD_CONTACTS: "Standard Contacts",
    NOTIFICATION_SCOPE: "Notification Scope",
    DEPARTMENT_ONLY: "Department Only",
    DEPARTMENT_AND_CHILDREN: "Department & Its Children",
    NON_MEDICAL_AUTHORISED: "Non-medical Authorised",
    SEARCH_DEPARTMENT: "Search Department",
    SELECT_DEPARTMENT: "Select Department",
    CONFIRM_RESET_PASSWORD_TEXT: "Are you sure would like to reset user's password?",
    DELETE_SPECIAL_CONTACT_ROLE: "Delete Special Contact Role",
    CONFIRM_DELETE_SPECIAL_CONTACT_ROLE: "Are you sure would like to delete special contact role?",
    WEEKLY_HOURS: "Weekly Hours",
    ACTIVE_POSITIONS: "Active Positions",
    POSITION_SCOPE: "Position Scope",
    DELETE_CONTACT: "Delete Contact",
    DELETE_CONTACT_CONFIRMATION: "Are you sure would like to delete {name} contact?",
    DELETE_CONTACTS_CONFIRMATION: "Are you sure would like to delete selected contacts?",
    EXCLUDE_AN_EMPLOYEE_FROM_ALERTS: "Exclude an employee from alerts",
    ADD_ALERT_EXCLUSION: "Add an Alert Exclusion",
    DATE_EXCLUDED_FROM: "Date Excluded From",
    DATE_EXCLUDED_TO: "Date Excluded To",
    REMOVE_ALERT_EXCLSUION_CONFIRMATION:
      "Are you sure would like to exclude the employee from {alertName} alert?",
    REMOVE_ALERT_EXCLSUION_MODAL_TITLE: "Remove alert exclusion",
    ADD_EXLUSION_ALERT_STEP_1_NEXT_BUTTON: "Next: Reason for Alert Exclusion",
    ADD_EXLUSION_ALERT_STEP_2_NEXT_BUTTON: "Save",
    CHOOSE_ALERT: "Choose Alert",
    REASON_FOR_ALERT_EXCLUSION: "Reason for exclusion",
    SPECIFY_ALERT_EXCLUSION: "Specify alert exclusion",
    SPECIFY_REASON_ALERT_EXCLUSION: "Specify Reason for Alert Exclusion",
    EDIT_ALERT_EXLUSION: "Edit Alert Exclusion",
    EXCLUSION_REASON: "Exclusion Reason",
    TRANSFER_NOTIFICATION: "Transfer Notification Contact",
    TRANSFER_MULTIPLE_NOTIFICATIONS: "Transfer {number} Notification Contacts",
    TRANSFER_NOTIFICATION_SUCCESS: "Notification was transferred successfully",
    ARE_YOU_SURE_ACTION_USER: `Are you sure would like to {action} "{user}" ?`,
    TRANSFER_MULTIPLE_NOTIFICATIONS_SUCCESS: "{number} notifications were transferred successfully",
    COPY_NOTIFICATION: "Copy Notification Contact",
    COPY_MULTIPLE_NOTIFICATIONS: "Copy {number} Notification Contacts",
    COPY_NOTIFICATION_SUCCESS: "Notification was copied successfully",
    COPY_MULTIPLE_NOTIFICATIONS_SUCCESS: "{number} notifications were copied successfully",
    ABSENCE_REVISION_HISTORY: "Absence Revision History",
    INTERACTION_DATE: "Interaction Date",
    CONSENT_GIVEN: "Consent Given",
    ABSENCE_UPDATE: "Absence Update",
    ABSENCE_NOTIFICATION_NUMBER: "Absence Notification #{id}",
    CURRENT_LEVEL: "Current Level",
    PROCESS_NAME: "Process Name",
    LEVEL_NUMBER: "Level Number",
    LEVEL_NAME: "Level Name",
    ACTION_TAKEN_BY: "Action Taken By",
    REVIEW_DATE: "Review Date",
    CHANGE_LEVEL: "Change Level",
    REVIEW_ID: "Review ID",
    RECORDED_BY: "Recorded By",
    DATE_RECORDED: "Date Recorded",
    OUTCOME: "Outcome",
    ABSENCE_ALERT: "Absence alert",
    ABSENCE_CANCELLED: "Absence cancelled",
    ABSENCE_CLOSED: "Absence closed",
    BATCHED_NOTIFICATION: "Batched notification",
    CALLBACK_FAILURE: "Callback failure",
    LAUNCH_REGISTRATION_EMAIL: "Launch registration email",
    NEW_ALERT_INFORMATION: "New alert information",
    OPEN_OVERDUE_ABSENCE: "Open overdue absence",
    OVERDUE_RTW_REMINDER: "Overdue rtw reminder",
    PLANNED_LEAVE_CONFIRMATION: "Planned leave confirmation",
    RESTRICTED_CONTENT_EMAIL: "Restricted content email",
    RTW_NOTIFICATION: "Rtw notification",
    STANDARD_REGISTRATION_EMAIL: "Standard registration email",
    STARTED_AND_CLOSED_NOTIFICATION: "Started and closed notification",
    WELLBEING_ALERT: "Wellbeing alert",
    RTW_EXPIRY_TEXT:
      "The Return to Work Interview for this absence was not completed by the relevant line manager(s) and expired on {date}.",
    IMPERSONATE: "Impersonate",
    IMPERSONATE_CONFIRM: "Are you sure you want to login to the system as {name}?",
    IMPORTANT_NOTE: "Important Note: ",
    IMPERSONATE_NOTE:
      "In line with information security policies, a record of this action will be logged for auditing purposes.",
    PROCEED: "Proceed",
    DOWNLOAD_REPORT: "Download Report",
    EXPORT_WITH_NAME: "{name}: Export Record",
    EXPORT: "Export",
    ABSENCE_HISTORY: "Absence History",
    NO_ACCESS: "No Access",
    ALERT: "Alert",
    EMPLOYEE_SMS_MESSAGES: "SMS Messages",
    VACCINATIONS: "Vaccinations",
    ADD_VACCINATION: "Add Vaccination",
    DELETE_VACCINATION_TITLE: "Delete Vaccination",
    DELETE_VACCINATION_QUESTION:
      "Are you sure would like to remove {vaccinationName} from this employee's record?",
    DATE_VACCINATED: "Date Vaccinated",
    BASIC_NOTIFICATION_TYPE_EXPLANATION:
      "Default setting. The user will see minimum information in notifications about the employee's absences. Absence Dates, Duration and Shift Patterns will be shown, but all sensitive information, such as Medical Absence Reasons, will not be available. The user will also have no access to the employee’s record.",
    STANDART_NOTIFICATION_TYPE_EXPLANATION:
      "The user will see the complete details of every absence in their notifications about the employee, including Medical Absence Reasons, but will not be able to complete return to work interviews, and will have no access to the employee record.",
    FULL_NOTIFICATION_TYPE_EXPLANATION:
      "The user will see the full details of every absence in their notifications and be able to view and complete return to work interviews. They will also have access to the employee record. Only choose this option if the user is a manager of the employee, or someone expected to know the full details of their absence record.",
    EMPLOYEE_TYPE_EXPLANATION: "Has access only to their own absence record.",
    CLIENT_ADMIN_TYPE_EXPLANATION:
      "Has access to the full details of every active and inactive employee record within their area of access, the ability to configure security settings, and to update other user's permissions.",
    FULL_ACCESS_TYPE_EXPLANATION:
      "Has access to the full details of every active and inactive employee record within their area of access.",
    ADVANCED_USER_TYPE_EXPLANATION:
      "Has access to the full details of every employee they are a Full Notification Contact for, and basic details for any other active and inactive employees within their area of access.",
    MANAGER_TYPE_EXPLANATION:
      "Has access only to the employee records they are a FULL notification contact for.",
    TREND_VIEWER_TYPE_EXPLANATION: "Has no access to any employee data.",
    DATA_TRANSFER_TYPE_EXPLANATION: "Has access to upload and export bulk employee data.",
    SUPPLIER_TYPE_EXPLANATION:
      "Has access to employee absences that have generated referrals, but no access to employee records.",
    DEVELOPER_TYPE_EXPLANATION:
      "Has access to the API Developer hub, enabling them to connect systems that can import or export all employee and absence data.",
    EMPLOYEE_EMAIL_SECURITY_NOTICE:
      "If you are adding an employee's personal email address or phone number, please ensure that you have their consent to pass that information on to GoodShape.",
    SUCCESS_SSO: "Success (SSO)",
    FAILURE_SSO: "Login failed(SSO)",
    FAILURE_SSO_ACCOUNT_LINKING: "Account linking failed",
    LOGOUT: "Sign Out",
    VIEW_PROFILE: "View Profile",
    GOODSHAPE_HEALTH: "GoodShape Health",
    GOODSHAPE_MOBILE: "GoodShape Mobile",
    GOODSHAPE_DEVELOPER_HUB: "GoodShape Developer Hub",
    APPLICATION: "Application",
    TREND_VIEWER: "Trend Viewer",
    SET_EMAIL_ADDRESS: "Set New Email Address",
    SET_EMAIL_MESSAGE:
      "Please provide the employee's new email address in order to proceed with updating their status.",
    DISABLE_USER_ACCOUNT_CONFIRMATION_MESSAGE:
      "Are you sure you want to delete this users email address? Doing so will remove their account and require them to re-register, and reconnect any SSO and MFA services, if they get access to the system again in the future.",
    YES_DISABLE_EMAIL: "Yes, disable email",
    DELETE_ABSENCE_RTW_INTERVIEW_CONFIRMATION_MESSAGE:
      "Are you sure you want to delete this return-to-work interview form? This action is irreversible, and the completed form will no longer be available.",
    KEEP_INTERVIEW_BTN_TEXT: "No, keep interview",
    DELETE_INTERVIEW_BTN_TEXT: "Yes, delete interview",
    DELETE_CREATE_INTERVIEW_BTN_TEXT: "Yes, delete interview and create new one",
    NOTIFICATION_CONTACT_UPDATE_TEXT:
      "Please note that if your organisation does any form of data synchronisation between GoodShapeCentral and your HR system, such as through our API Developer Hub or a Staff In Post (SIP) file, there is a risk that this notification contact may be removed if it is not also included in such updates.",
    NOTIFICATION_CONTACT_UPDATE_CONFIRMATION_WARNING_RECIPIENT:
      "I confirm that the selected contact is authorised to receive <strong>{notificationType}</strong> notifications for <strong>{recipientName}</strong>.",
    NOTIFICATION_CONTACT_UPDATE_CONFIRMATION_WARNING_TARGET:
      "I confirm that <strong>{recipientName}</strong> is authorised to receive <strong>{notificationType}</strong> notifications for the selected employee.",
    THIRD_PARTY_APP: "3rd Party Integration",

    NOTIFICATION_TYPES: "Notification Types",
    BASIC_NOTIFICATION_TYPE:
      "The contact will see minimum information in notifications about the employee's absences. Absence Dates, Duration and Time Lost will be shown, but all sensitive information, such as Medical Absence Reasons, will not be included. The contact will also have no access to the employee’s record on GoodShapeCentral.",
    STANDARD_NOTIFICATION_TYPE:
      "The contact will see the complete details of every absence in their notifications about an employee, including Absence Reasons, but will not be able to complete tasks, such as return to work interviews, and will have no access to the employee record on GoodShapeCentral.",
    FULL_NOTIFICATION_TYPE:
      "The contact will see the full details of every absence in their notifications and be able to view and complete all tasks. They will also have access to the employee record. This option is designed for the manager(s) of the employee, or someone expected to know the full details of their absence record.",
    DATA_EXPOSURE_INDEX: "Data Exposure Index",
    EXPOSURE_INDEX_LOW: "Low (L)",
    EXPOSURE_INDEX_MEDIUM: "Medium (M)",
    EXPOSURE_INDEX_HIGH: "High (H)",
    EXPOSURE_LOW_DESCRIPTION: "The notification contact sees a very limited amount of data.",
    EXPOSURE_MEDIUM_DESCRIPTION:
      "The notification contact sees absence data, including the absence reason, which may potentially be sensitive or personal information.",
    EXPOSURE_HIGH_DESCRIPTION:
      "The notification contact sees all of the data in an employee's absence record, including personal information, and potentially sensitive information such as absence reasons, fit notes and the answers to dynamic questions.",

    SENT_TO_DESCRIPTION:
      "Any listed contacts in the Department Recipients table are set-up as notification contacts for the department the employee is currently assigned to. If the employee is moved to a different department, different department notification contacts may appear.",
    RECEIVED_FOR_DESCRIPTION:
      "The selected employee is a department notification contact for the listed departments. As such, they will be notified of any absences by any employee in one of those departments.",
    TRANSFER_EMPLOYEES: "Transfer Employees",
    TRANSFERRED_EMPLOYEES: "Transferred Employees",
    SELECT_NEW_EMPLOYEE: "Select New Employee",
    SELECT_NOTIFICATION_CONTACT: "Select Notification Contact",
    SELECT_NEW_NOTIFICATION_CONTACT: "Select New Notification Contact",
    NOTIFICATION_CONTACT_TRANSFER_TEXT_RECIPIENT:
      "The following notification contact(s) will be removed from <strong>{ownerName}</strong> and transferred to the selected employee:",
    NOTIFICATION_CONTACT_TRANSFER_TEXT_TARGET:
      "The notification contact <strong>{ownerName}</strong> will no longer receive notifications for the following employees. Their notifications will instead to be sent to the new notification contact:",
    NOTIFICATION_CONTACT_COPY_TEXT_RECIPIENT:
      "The following notification contact(s) will be copied from <strong>{ownerName}</strong> and added to the selected employee:",
    NOTIFICATION_CONTACT_COPY_TEXT_TARGET:
      "The following employees will be copied from <strong>{ownerName}</strong> and added to your selected notification contact:",
    NOTIFICATION_CONTACT_INFO_TEXT_RECIPIENT:
      "These contacts are notified of <strong>{ownerName}</strong>’s absences:",
    NOTIFICATION_CONTACT_INFO_TEXT_TARGET:
      "<strong>{ownerName}</strong> is notified of these employee's absences:",
    START_DATE_DEFINITION:
      "This is the Start Date and Time of the absence. It represents the exact minute from which the employee was absent and began missing work.",
    LAST_ABSENCE_DAY_DEFINITION:
      "The Last Absent Day is defined as the last working day that the employee missed due to their absence.",
    RTW_DATE_DEFINITION:
      "This is the date and time that the employee returned to work following their absence. If an absence has a status of Open, the RTW date should be considered an estimate that is subject to change.",
    DATE_REPORTED_DEFINITION:
      "This is the date and time that the absence was logged on the GoodShape system. Ideally, it should always be before the Start Date, otherwise it means the absence has been recorded late.",
    FIT_DATE_DEFINITION:
      "Fit Date shows the earliest day the employee was estimated to be fit and able to resume working. If it is earlier than the RTW Date, it implies that the employee would be capable of working if you needed to call them back in earlier than their scheduled return. For the majority of absences, it will be the same as the RTW date.",
    DATE_DEFINITIONS: "Date Definitions",
    ACCESS_DATE: "Access Date",
    USER_NAME: "User Name",
    POSITION_START_DATE: "Position Start Date",
    POSITION_END_DATE: "Position End Date",
    LINKED_ABSENCES: "Linked Absences",
    LINK: "Link",
    SUCCESS_OTP_CONFIG: "Success",
    THIS_POSITION_IS_NOT_LINKED_TO_ABSENCES: "This position is not linked to any absences.",
    THIS_POSITION_IS_USED_IN_ABSENCES: "This position is used in the following absences:",
    LINKED_ABSENCE_BLOCKED_TOOLTIP:
      "You cannot change the Position Start Date to be after the Start Date of a linked absence. The same principle applies to Position End Date and RTW Dates too. If you need to make this change, you must first assign the impacted absence to a new position.",
  },
};
